module.exports = __webpack_public_path__ + "img/Icon-block-checkup-32px-turkoois.3fd3f673.svg";